var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgExchangeIcon = function SvgExchangeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.73,
    height: 9.589,
    viewBox: "0 0 10.73 9.589",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8413",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 8413",
    d: "M211.006-3267.888h-.939a4.55,4.55,0,0,0-4.523-4.112,4.55,4.55,0,0,0-4.545,4.544,4.55,4.55,0,0,0,4.545,4.545,4.558,4.558,0,0,0,2.856-1.009.434.434,0,0,0,.064-.609.434.434,0,0,0-.609-.064,3.635,3.635,0,0,1-2.311.817,3.683,3.683,0,0,1-3.679-3.679,3.683,3.683,0,0,1,3.679-3.679,3.683,3.683,0,0,1,3.651,3.247h-.871a.218.218,0,0,0-.186.333l1.34,2.178a.219.219,0,0,0,.372,0l1.34-2.178a.218.218,0,0,0-.186-.333",
    transform: "translate(-200.75 3272.25)",
    fill: "currentColor",
    stroke: "#b7c7d6",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExchangeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exchangeIcon.5d79a496.svg";
export { ForwardRef as ReactComponent };